import { ipc_invoke } from '@/tauri/ipc';

/**
 * Mirror of the Rust `InstallSource` DTO (`src-tauri/src/ipc/install_source.rs`),
 * serialized `camelCase`. Reported once at startup and attached as a
 * device-scoped analytics context (APP-5958).
 *
 * - `mdmProvider` — normalized vendor key (`'intune'`, `'workspace_one'`, …),
 *   or `null` when the device isn't MDM-enrolled / detection is unsupported.
 * - `mdmProviderRaw` — raw enrollment `ProviderID`, so unmapped vendors stay
 *   visible in analytics without a new build.
 * - `isDomainJoined` / `isAzureAdJoined` — Windows join state; `null` off-Windows.
 */
export type InstallSource = {
  mdmProvider: string | null;
  mdmProviderRaw: string | null;
  isDomainJoined: boolean | null;
  isAzureAdJoined: boolean | null;
};

/**
 * Detect the device's install source / MDM posture (APP-5958). Thin wrapper over
 * the `get_install_source` Tauri command, which returns the standard `IpcResponse`
 * envelope — `ipc_invoke` unwraps `result`, surfaces any `error_code` via the
 * shared toast/i18n path, and already rejects when not running under Tauri.
 */
export async function getInstallSource(): Promise<InstallSource> {
  return ipc_invoke('get_install_source', {}).then(
    (res: { data: InstallSource }) => res.data
  );
}
